import { render, staticRenderFns } from "./PriceSliderFilter.vue?vue&type=template&id=5b310f15&scoped=true&"
import script from "./PriceSliderFilter.vue?vue&type=script&lang=ts&"
export * from "./PriceSliderFilter.vue?vue&type=script&lang=ts&"
import style0 from "./PriceSliderFilter.vue?vue&type=style&index=0&id=5b310f15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b310f15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b310f15')) {
      api.createRecord('5b310f15', component.options)
    } else {
      api.reload('5b310f15', component.options)
    }
    module.hot.accept("./PriceSliderFilter.vue?vue&type=template&id=5b310f15&scoped=true&", function () {
      api.rerender('5b310f15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/filter/PriceSliderFilter.vue"
export default component.exports